import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import NewsDetail from './pages/NewsDetail';
import NotFound from './pages/NotFound';
import { ThemeProvider } from './context/ThemeContext';

const ResumiPraTiApp: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <div className="ResumiPraTiApp">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default ResumiPraTiApp